import { createContext, useContext } from "react"

export interface ThemeState {
  theme?: any
  logo?: string
  primaryColor?: string
  colors?: object
}

export type ThemeContextData = ThemeState

export const ThemeContext = createContext<ThemeContextData>({} as ThemeContextData)

function useTheme(): ThemeContextData {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error("useTheme must be used within an ThemeProvider")
  }

  return context
}

export { useTheme }
